import { Grid, Text } from '@simplywallst/ui-core';
import { TextWrapper } from './styled';

interface Props {
  earningsGrowth: string;
  salesGrowth: string;
  analystCount: number | null;
}

export const GrowthMetricTooltip = ({
  analystCount,
  earningsGrowth,
  salesGrowth,
}: Props) => {
  return (
    <TextWrapper
      gap="12px"
      rowGap="8px"
      templateRows={`auto${analystCount !== null ? ' auto' : ''}`}
      templateColumns="auto auto"
      data-cy-id="growth-ratio-tooltip"
    >
      {analystCount !== null && (
        <Grid column="span 2" data-cy-id="current-analyst-count">
          <Text typography="tiny" color="spaceGray">
            Growth Forecasts from <strong>{analystCount} analysts</strong>
          </Text>
        </Grid>
      )}
      <Grid data-cy-id="current-earnings-growth">
        <Text typography="xSmallStrong" color="spaceGray">
          <Text as="span" typography="xLargeStrong" color="spaceGray">
            {earningsGrowth}
          </Text>
        </Text>
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.5}>
          Earnings Growth
        </Text>
      </Grid>
      <Grid data-cy-id="current-sales-growth">
        <Text typography="xSmallStrong" color="spaceGray">
          <Text as="span" typography="xLargeStrong" color="spaceGray">
            {salesGrowth}
          </Text>
        </Text>
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.5}>
          Sales Growth
        </Text>
      </Grid>
    </TextWrapper>
  );
};
